module.exports = __webpack_public_path__ + "affd35c88b80243d2922f8a8d4cf6ded.svg";